import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const toLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

const DEFAULTS = { number: 0, multiselect: [], checkbox: false, list: "" };

export function emptyForm(fields) {
  const f = { file_id: "", file_name: "" };
  fields.forEach((x) => {
    f[x.name] = x.default ?? DEFAULTS[x.type] ?? "";
  });
  return f;
}

export function toForm(fields, row) {
  const f = emptyForm(fields);
  fields.forEach((x) => {
    const v = row[x.name];
    if (v === undefined || v === null) return;
    if (x.type === "list") f[x.name] = v.join("\n");
    else if (x.type === "datetime") f[x.name] = toLocal(v);
    else f[x.name] = v;
  });
  f.file_id = row.file_id || "";
  f.file_name = row.file_name || "";
  return f;
}

export function toPayload(fields, form) {
  const p = {};
  fields.forEach((x) => {
    const v = form[x.name];
    if (x.type === "file") {
      p.file_id = form.file_id;
      p.file_name = form.file_name;
    } else if (x.type === "number" || x.numeric) p[x.name] = Number(v) || 0;
    else if (x.type === "list") p[x.name] = String(v).split("\n").map((s) => s.trim()).filter(Boolean);
    else if (x.type === "datetime") p[x.name] = v ? new Date(v).toISOString() : "";
    else p[x.name] = v;
  });
  return p;
}

export function useFieldOptions(fields) {
  const [opts, setOpts] = useState({});
  useEffect(() => {
    fields.filter((f) => f.optionsFrom).forEach(async (f) => {
      try {
        const { data } = await api.get(f.optionsFrom.url);
        setOpts((o) => ({ ...o, [f.name]: data.map((x) => ({ value: x.id, label: f.optionsFrom.label(x) })) }));
      } catch {
        setOpts((o) => ({ ...o, [f.name]: [] }));
      }
    });
  }, [fields]);
  return opts;
}
